<template>
    <div>
        <modal
            class="new-modal-small sent-call-report-success"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #dfe8f4 !important; height: 10em !important;">
                <span class="text-secondary" style="font-weight:600;font-size:16px;text-align:center;margin:15px">{{message}}</span>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","message"],
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/LoaderModal.vue